import * as React from "react";
import { useEffect } from "react";

import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppNavbar from "../components/AppNavbar";
import Header from "../components/Header";
import SideMenu from "../components/SideMenu";
import AppTheme from "../shared-theme/AppTheme";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "../theme/customizations";
import MainGridAdminConfigurations from "./admin-configurations/MainGridAdminConfigurations";
import PageErrorBoundary from "../components/PageErrorBoundary";
import { getListById } from "../api/dashboardAPI";
import axiosInstance from "../config/axiosInterceptor";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function AdminConfigurations(props) {
  useEffect(() => {
    // getListById(1, 3).then(res => {
    //   console.log("GetListById/1/3 response:", res.data);
    // }).catch(err => {
    //   console.error("GetListById/1/3 error:", err);
    // });

    axiosInstance.get("/api/Dashboard/GetListById/1/null/3").then(res => {
      console.log("GetListById/1/null/3 response:", res.data);
    }).catch(err => {
      console.error("GetListById/1/null/3 error:", err);
    });
  }, []);

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex" }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          <PageErrorBoundary>
            <Stack
              spacing={2}
              sx={{
                alignItems: "center",
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              <Header />
              <MainGridAdminConfigurations />
            </Stack>
          </PageErrorBoundary>
        </Box>
      </Box>
    </AppTheme>
  );
}
